import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

interface LoaderProps {
  className?: string;
}

const Loader = ({ className }: LoaderProps) => {
  return (
    <div
      className={cn(
        "inline-flex justify-center items-center p-1 size-10 self-center",
        className
      )}
    >
      <Loader2 className={`animate-spin h-full w-full`} />
    </div>
  );
};

export default Loader;
